import React from "react";
import { connect } from "react-redux";

import Color from "@mapmycustomers/shared/enum/Color";
import { EntityTypesSupportedByMapsPage, Group } from "@mapmycustomers/shared/types/entity";

import { getGroupsForEntity } from "@app/store/groups";
import { RootState } from "@app/store/rootReducer";

import ColorBadge from "../../ColorBadge/ColorBadge";

import ColorKey from "./ColorKey";
import styles from "./GroupColorKey.module.scss";

interface OwnProps {
  entityType: EntityTypesSupportedByMapsPage;
}

interface Props extends OwnProps {
  groups: Group[];
}

const GroupColorKey: React.FC<Props> = ({ groups }) => {
  return (
    <ColorKey>
      <div className={styles.groupList}>
        {groups.map((group) => (
          <div key={group.id}>
            <ColorBadge color={group.color ?? Color.BLACK} label={group.name} />
          </div>
        ))}
      </div>
    </ColorKey>
  );
};

const mapStateToProps = (state: RootState, { entityType }: OwnProps) => ({
  groups: getGroupsForEntity(state)(entityType),
});

export default connect(mapStateToProps)(GroupColorKey);
